import { jsxs as c, jsx as e } from "react/jsx-runtime";
import { Text as m } from "@zapier/design-system";
import { Icon as _ } from "@zapier/zinnia-icons";
import { ZSL_ASSET_TYPES as y } from "../../constants/constants.es.js";
import { isZSLAssetWithZdl as T, isParamArray as h } from "../../utils/zslTypeguard.es.js";
import { replaceParamsInTitle as v } from "../../utils/replaceParamsInTitle.es.js";
const I = "_sidebarSectionTitle_leh6x_1", f = "_assetTypes_leh6x_6", u = "_assetType_leh6x_6", x = "_assetTypeItems_leh6x_16", S = "_assetTypeItem_leh6x_16", N = "_assetIcon_leh6x_30", s = {
  sidebarSectionTitle: I,
  assetTypes: f,
  assetType: u,
  assetTypeItems: x,
  assetTypeItem: S,
  assetIcon: N
};
var j = function(d) {
  var n = d.template;
  return n.zsl && /* @__PURE__ */ c("section", { children: [
    /* @__PURE__ */ e(m, { type: "ParagraphHeader2", className: s.sidebarSectionTitle, tag: "h2", children: "Created assets" }),
    /* @__PURE__ */ e("div", { className: s.assetTypes, children: y.map(function(r) {
      var i, t = (i = n.zsl) === null || i === void 0 ? void 0 : i[r.name];
      return !t || t.length === 0 || !Array.isArray(t) ? null : /* @__PURE__ */ c("div", { className: s.assetType, children: [
        /* @__PURE__ */ e(m, { type: "MinimalPrint3", children: "".concat(r.displayName, " (").concat(t.length, ")") }),
        /* @__PURE__ */ e("ul", { className: s.assetTypeItems, children: t.map(function(a) {
          var l, o, p = (l = n.zsl) === null || l === void 0 ? void 0 : l.parameters;
          if (T(a))
            return /* @__PURE__ */ c("li", { className: s.assetTypeItem, children: [
              /* @__PURE__ */ e(_, { name: r.icon, color: "BrandOrange", size: 18, className: s.assetIcon }),
              /* @__PURE__ */ e(m, { type: "Body3", children: v(a.name || a.title || ((o = a.config) === null || o === void 0 ? void 0 : o.chatbotName) || "Untitled", h(p) ? p : []) })
            ] }, a.id);
        }) })
      ] }, r.name);
    }) })
  ] });
};
export {
  j as CreatedAssetsSection
};
//# sourceMappingURL=CreatedAssetsSection.es.js.map
